export default {
    getItems:         { method: 'get', url: 'catalog-grid/items' },
    getSummary:       { method: 'get', url: 'catalog-grid/items/summary' },
    getItemsDistinct: { method: 'get', url: 'catalog-grid/items/distinct' },
    putItem:          { method: 'put', url: 'catalog-grid/items/{id}' },
    bulkUpdateItems:  { method: 'put', url: 'catalog-grid/items-bulk' },
    getPreferences:   { method: 'get', url: 'catalog-grid/preferences' },
    savePreferences:  { method: 'put', url: 'catalog-grid/preferences' },
    getIndicatorScheduleClash: { method: 'get', url: 'catalog-grid/indicators/schedule-clash' },
    getIndicatorModularizationMismatch: { method: 'get', url: 'catalog-grid/indicators/modularization-mismatch' },
    getIndicatorMixedJoin: { method: 'get', url: 'catalog-grid/indicators/mixed-join' },
    getIndicatorActiveWithoutOffer: { method: 'get', url: 'catalog-grid/indicators/active-without-offer' },
    getIndicatorEquivalentAlreadyOffered: { method: 'get', url: 'catalog-grid/indicators/equivalent-already-offered' },
    getIndicatorDifferentCurriculum: { method: 'get', url: 'catalog-grid/indicators/different-curriculum' },
    getIndicatorGraduatingPendingDiscipline: { method: 'get', url: 'catalog-grid/indicators/graduating-pending-discipline' },
    getIndicatorMissingModality: { method: 'get', url: 'catalog-grid/indicators/missing-modality' },
    getIndicatorMissingDay: { method: 'get', url: 'catalog-grid/indicators/missing-day' },
    getIndicatorSameOfferDifferentDayCombo: { method: 'get', url: 'catalog-grid/indicators/same-offer-different-day-combo' },
    getIndicatorSameOfferDifferentModality: { method: 'get', url: 'catalog-grid/indicators/same-offer-different-modality' },
    getIndicatorsEvolution: { method: 'get', url: 'catalog-grid/indicators/evolution' },
}
